import type { FaireProductEntity } from "../../entity_types/product";

export const p_m4sqtmz375: FaireProductEntity = {
  token: "p_m4sqtmz375",
  type: "product",
  name: "Moringa Herbal Supplement Capsules-120 Capsules",
  brandToken: "b_3z46kjdoak",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c49e2d9eddb1aa68fd3afb7efc806ddf8d4c6cf1f17bc4446e172e61d2836d7d.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b7fe1220db32075bd579a038f4d8492bd82f9f0fb540d0374b1c3ddb514beb55.jpeg",
    "https://cdn.faire.com/fastly/570feb9683b8a8a1699b84f0f10cd13ff3faed062901cf83272d72ed559cb871.webp",
    "https://cdn.faire.com/fastly/b2ede23c6a8ed5e35d8daac58201b36c8984f2962e40e3e9681437d85463f3b9.webp",
    "https://cdn.faire.com/fastly/a6a6579c6bd3a5b23b394ea19ad3d8e3382d8d3cba9436d248a67e32e9488147.jpeg",
    "https://cdn.faire.com/fastly/2b457e748713db6b6583e6534a82cf8a65e30f7e3dd3fd0aecc093fbb577f2f6.webp",
    "https://cdn.faire.com/fastly/47b6c023f0d6ec44137e0ab9aa3f097f4911b31f423bbe05d202f358ab58f11f.webp",
    "https://cdn.faire.com/fastly/f85d4087b7975b502b236a54acc26b7f98ae3193c23a41d0378a72f2e05950a6.webp",
    "https://cdn.faire.com/fastly/ab463c8b25fca86c91fe34572d0c82d3775467f863fc60e78ffbc04b36264919.webp",
    "https://cdn.faire.com/fastly/0f9d180a69aa7380f562d24794d0733e6db27acdf9c80c2724d81e036a71f693.jpeg",
  ],
  priceDollars: 22.86,
  description:
    "Meet the “Miracle Tree” - Moringa! This supplement stands out from the rest thanks to its high concentration of natural antioxidants and bioactive plant compounds that make it one of the most nutrient-dense plants in the world. Its robust composition offers a comprehensive approach to well-being that nourishes your whole body in a simple and easy way. \n\nAs a natural energizing superfood, Moringa helps maintain overall wellness by supporting the body's defense against oxidative stress and cell damage. Its antioxidant properties combat free radicals, promoting healthy aging and strengthening the immune system, preparing your body to fend off any ailments that come your way! ",
  tags: [],
  msrpDollars: 45.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:01.266Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
